import { MiniIcons } from 'owa-mini-icons';
import { PersonaMeetingResponse } from '../components/Persona.Props';

export default function determineMeetingResponseIcon(
    personaMeetingResponse: PersonaMeetingResponse,
    isSolid?: boolean
) {
    switch (personaMeetingResponse) {
        case PersonaMeetingResponse.Accept:
            return !!isSolid ? MiniIcons.CompletedSolid : MiniIcons.Accept;
        case PersonaMeetingResponse.Decline:
            return !!isSolid ? MiniIcons.StatusErrorFull : MiniIcons.Cancel;
        case PersonaMeetingResponse.Tentative:
            return !!isSolid ? MiniIcons.UnknownSolid : MiniIcons.Help;
        default:
            // Ideally, this case doesn't happen
            return MiniIcons.Help;
    }
}
